import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';

import { CommonModule } from '@angular/common';

import { WorkflowApiService }
from '../../core/services/workflow-api.service';
import { DynamicFormLayout } from '../../core/models/dynamic-form.models';
import { Router } from '@angular/router';

@Component({
  selector: 'swerp-workflow-action-bar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-wrap items-center gap-1.5">
    <button
      *ngFor="let a of actions"
      (click)="onAction(a)"
      class="kt-btn kt-btn-outline kt-btn-primary">

      <i [ngClass]="getIconClass(a.code)" class="ki-filled"></i>

      {{ a.label }}

    </button>

    <button
      (click)="onView()"
      class="kt-btn kt-btn-outline kt-btn-primary">

      <i class="ki-filled ki-eye"></i>

      View

    </button>
     </div>
  `
})
export class WorkflowActionBarComponent
implements OnInit, OnChanges {

  @Input() metaEntity: DynamicFormLayout = {
    placement: 'drawer'
  } as DynamicFormLayout;

  @Input() module!: string;

  @Input() entity!: string;

  @Input() recordId!: string;

  @Output() actionClick = new EventEmitter<any>();

  currentState = '';

  actions: any[] = [];

  comment = '';

  showComment = false;

  pendingAction: any;

  loading = false;

  private lastEntity = '';

  private lastRecordId = '';

  constructor(
    private api: WorkflowApiService,
    private router: Router
  ) {}

  ngOnInit(): void {

    this.loadActions();

  }

  ngOnChanges(
    changes: SimpleChanges
  ): void {

    if (
      changes['entity'] ||
      changes['recordId']
    ) {

      this.loadActions();

    }

  }

  private loadActions(): void {

    if (
      !this.entity ||
      !this.recordId
    ) {

      this.actions = [];

      this.currentState = '';

      return;

    }

    //
    // Prevent duplicate API calls
    //
    if (
      this.lastEntity === this.entity &&
      this.lastRecordId === this.recordId
    ) {

      return;

    }

    this.lastEntity = this.entity;

    this.lastRecordId = this.recordId;

    this.actions = [];

    this.loading = true;

    console.log(
      'Loading Workflow Actions',
      this.entity,
      this.recordId
    );

    this.api
      .getActions(
        this.entity,
        this.recordId
      )
      .subscribe({

        next: res => {

          console.log(
            'Workflow Actions',
            res
          );

          this.currentState =
            res.currentState;

          this.actions =
            res.actions || [];

          this.loading = false;

        },

        error: err => {

          console.error(
            err
          );

          this.actions = [];

          this.loading = false;

        }

      });

  }

  onView(){

    if(this.metaEntity.placement === 'drawer') {
      this.actionClick.emit({
        type: 'view',
        entity: this.entity,
        recordId: this.recordId
      });
    }
    else if(this.metaEntity.placement === 'page') {
      this.router.navigate(
        [
          '/app/', 
          this.module, 
          this.metaEntity.transType === 'MASTER' ? 'master' : 'trans', 
          this.entity,
          this.recordId
        ]);
    }

  }

  onAction(
    action: any
  ) {

    if (
      action.requiresComment
    ) {

      this.pendingAction = action;

      this.showComment = true;

      return;

    }

    this.api
      .execute(
        this.entity,
        this.recordId,
        action.code
      )
      .subscribe(() => {

        this.loadActions();

      });

  }

  confirm() {

    this.api
      .execute(
        this.entity,
        this.recordId,
        this.pendingAction.code,
        this.comment
      )
      .subscribe(() => {

        this.comment = '';

        this.showComment = false;

        this.pendingAction = null;

        this.loadActions();

      });

  }

  getIconClass(action: any): string {
    if (action === 'APPROVE') {
      return 'ki-check';
    }
    else if (action === 'REJECT') {
      return 'ki-cross';
    }
    else if (action === 'PRINT') {
      return 'ki-printer';
    }
    else {
      return 'ki-setting-4';
    }
  }

}